import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { clearFilter } from "../components/LocalReturns/filterConfig";
import apiClient from "../utils/api/apiClient";
import { APIEndpoints } from "../utils/api/apiConfig";
import { StoreIcon } from "../components/Icons/StoreIcon";

import axios from "axios";

const CancelToken = axios.CancelToken;
let cancel;

const LocalReturnsContext = React.createContext({});
export function useLocalReturnsState() {
  return React.useContext(LocalReturnsContext);
}
const initialFilter = {
  "filter.receiptNo": "",
  "filter.orderNo": "",
  "filter.shippingOrderNo": "",
  "filter.customer": "",
};

const LocalReturnsProvider = ({ children }) => {
  const [loaded, setLoaded] = useState(false);
  const [pageOffset, setPageOffset] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [showAllLocalReturns, setShowAllLocalReturns] = useState(false);
  const [filter, setFilter] = useState(initialFilter);
  const [sorting, setSorting] = useState("displayName");
  const [selectedRow, setSelectedRow] = useState(false);
  const [localReturns, setLocalReturns] = useState([]);
  const [tableIsLoading, setTableIsLoading] = useState(false);
  const [showOverlayLeft, setShowOverlayLeft] = useState(false);
  const [filterLocalInventory, setFilterLocalInventory] = useState(null);
  const [forceReloadLocalReturns, setForceReloadLocalReturns] = useState(false);
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  const [allCheckBoxesSelected, setAllCheckBoxesSelected] = useState(false);
  const [allSelectedLoading, setAllSelectedLoading] = useState(false);
  const [initialTableId, setInitialTableId] = useState(null);
  const [storehouseFilter, setStorehouseFilter] = useState(null);
  const [openStorehouseFilter, setOpenStorehouseFilter] = useState(false);
  const [openDateRangeFilter, setOpenDateRangeFilter] = useState(false);
  const [startDateFilter, setStartDateFilter] = useState(null);
  const [endDateFilter, setEndDateFilter] = useState(null);
  const [openOfficeFilter, setOpenOfficeFilter] = useState(false);
  const [openCostCenterFilter, setOpenCostCenterFilter] = useState(false);
  const [officeFilter, setOfficeFilter] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [costCenterFilter, setCostCenterFilter] = useState("");
  const [costCenterName, setCostCenterName] = useState("");
  const { t } = useTranslation();
  const [lastParams, setLastParams] = useState(
    JSON.stringify({
      pageOffset,
      pageLimit,
      filter,
      showAllLocalReturns,
      sorting,
    })
  );
  const [filterReceipt, setFilterReceipt] = useState(null);
  const resetFilter = (test = null) => {
    clearFilter();
    setFilter(initialFilter);
    setOfficeFilter(null);
    setCostCenterFilter(null);
    setStorehouseFilter(null);
    setStartDateFilter(null);
    setEndDateFilter(null);
    if (!showAllLocalReturns) {
      setLocalReturns([]);
      setTotalCount(0);
    }
  };
  //when closing OverlayLeft
  const updateOverlayLeftStates = () => {
    officeFilter ? setOpenOfficeFilter(true) : setOpenOfficeFilter(false);
    costCenterFilter
      ? setOpenCostCenterFilter(true)
      : setOpenCostCenterFilter(false);
    storehouseFilter
      ? setOpenStorehouseFilter(true)
      : setOpenStorehouseFilter(false);
    startDateFilter || endDateFilter
      ? setOpenDateRangeFilter(true)
      : setOpenDateRangeFilter(false);
  };
  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      "filter.storehouseId": storehouseFilter?.storehouseId || "",
    }));
  }, [storehouseFilter]);
  useEffect(() => {
    setFilter((prev) => ({ ...prev, "filter.officeId": officeFilter || "" }));
  }, [officeFilter]);
  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      "filter.costCenterId": costCenterFilter || "",
    }));
  }, [costCenterFilter]);
  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      "filter.startDate": startDateFilter || "",
    }));
  }, [startDateFilter]);
  useEffect(() => {
    setFilter((prev) => ({ ...prev, "filter.endDate": endDateFilter || "" }));
  }, [endDateFilter]);

  const handleLocalChangeCheckbox = (id) => {
    if (allCheckBoxesSelected) {
      setAllCheckBoxesSelected(false);
    }
    if (selectedCheckBoxes.includes(id)) {
      var index = selectedCheckBoxes.indexOf(id);
      var newValues = [...selectedCheckBoxes];
      newValues.splice(index, 1);
      setSelectedCheckBoxes(newValues);
    } else {
      setSelectedCheckBoxes((prev) => [...prev, id]);
    }
  };

  //cancel previous calls that are still pending if existing
  const cancelPrevious = () => {
    cancel && cancel();
  };

  const loadLocalReturns = async () => {
    cancelPrevious();
    const cancelToken = new CancelToken(function executor(c) {
      cancel = c;
    });
    try {
      let params = getParams();
      const response = await apiClient.getJson(
        APIEndpoints.localReturnReceipts().searchReturns,
        params,
        true,
        true,
        true,
        { cancelToken }
      );
      if (response.headers["x-total-count"]) {
        setTotalCount(Number(response.headers["x-total-count"]));
      } else {
        setTotalCount(0);
      }
      return response.data;
    } catch (e) {
      if (axios.isCancel(e)) {
        console.log("cancelled by cancelToken");
      }
      return null;
    }
  };

  const getParams = () => {
    const filterWithValues = { ...filter };
    Object.keys(filterWithValues).forEach((filterName) => {
      if (filterWithValues[filterName] === "") {
        delete filterWithValues[filterName];
      }
    });
    let params = { ...filterWithValues };
    params["page.offset"] = pageOffset;
    params["page.limit"] = pageLimit;
    if (sorting) {
      params["sort"] = sorting;
    }
    return params;
  };
  const appendData = (data) => {
    return data.map((item) => ({
      ...item,
      actions: (
        <span>
          <span>
            <Link
              to={`/localstorage/returns/${item.id}/store`}
              onClick={(e) => {
                e.stopPropagation();
              }}
              title={t("goodsReceiptsTable:storeAction")}
            >
              <StoreIcon color="#000000" />
            </Link>
          </span>
        </span>
      ),
      checkBox: (
        <span>
          <input
            type="checkbox"
            id={item.id}
            name="scales"
            checked={selectedCheckBoxes.includes(item.id)}
            onChange={() => {}}
          ></input>
        </span>
      ),
    }));
  };

  useEffect(() => {
    const newParams = JSON.stringify({
      pageOffset,
      pageLimit,
      filter,
      showAllLocalReturns,
      sorting,
    });
    const filtersHaveChanged =
      JSON.stringify(filter) !== JSON.stringify(JSON.parse(lastParams).filter);
    const sortingHasChanged =
      JSON.stringify(sorting) !==
      JSON.stringify(JSON.parse(lastParams).sorting);
    //go to page 1 if filter or sorting have changed
    if (pageOffset !== 0 && (sortingHasChanged || filtersHaveChanged)) {
      var newParamsFilter = JSON.parse(lastParams);
      newParamsFilter.filter = filter;
      newParamsFilter.sorting = sorting;
      setLastParams(JSON.stringify(newParamsFilter));
      setPageOffset(0);
    } else if (lastParams !== newParams || forceReloadLocalReturns) {
      setForceReloadLocalReturns(false);
      setLastParams(newParams);
      (async () => {
        if (
          showAllLocalReturns ||
          Object.keys(filter).reduce(
            (acc, item) => acc || filter[item] !== "",
            false
          )
        ) {
          setTableIsLoading(true);
          const result = await loadLocalReturns();
          if (result) {
            // add action icons
            let preparedResult = appendData(result);
            setLocalReturns(preparedResult);
            setTableIsLoading(false);
          }
        } else {
          cancelPrevious();
          setLocalReturns([]);
          setTotalCount(0);
          setTableIsLoading(false);
        }
        if (filtersHaveChanged) {
          //setSelectedCheckBoxes([])
          setAllCheckBoxesSelected(false);
        }
      })();
    }
    //eslint-disable-next-line
  }, [
    pageOffset,
    pageLimit,
    filter,
    showAllLocalReturns,
    sorting,
    forceReloadLocalReturns,
    setForceReloadLocalReturns,
  ]);

  const selectAll = () => {
    if (allCheckBoxesSelected || localReturns.length < 1) {
      setAllCheckBoxesSelected(false);
      setSelectedCheckBoxes([]);
    } else {
      setAllSelectedLoading(true);
      const filterWithValues = { ...filter };
      Object.keys(filterWithValues).forEach((filterName) => {
        if (filterWithValues[filterName] === "") {
          delete filterWithValues[filterName];
        }
      });
      apiClient
        .getJson(APIEndpoints.localReturnReceipts().searchReturns, {
          ...filterWithValues,
        })
        .then((result) => {
          if (result) {
            const arrayOfAllIds = result.map((obj) => obj.id);
            setSelectedCheckBoxes(arrayOfAllIds);
          }
        })
        .finally(() => {
          setAllCheckBoxesSelected(true);
          setAllSelectedLoading(false);
        });
    }
  };

  useEffect(() => {
    // add action icons
    // todo only change selected one
    setLocalReturns((prev) =>
      prev.map((item) => ({
        ...item,
        checkBox: (
          <span>
            <input
              type="checkbox"
              id={item.id}
              name="scales"
              checked={selectedCheckBoxes.includes(item.id)}
              onChange={() => {}}
            ></input>
          </span>
        ),
      }))
    );
  }, [selectedCheckBoxes]);

  const contextValues = {
    setSelectedCheckBoxes,
    allCheckBoxesSelected,
    selectAll,
    allSelectedLoading,
    selectedCheckBoxes,
    handleLocalChangeCheckbox,
    loaded,
    setLoaded,
    pageOffset,
    setPageOffset,
    pageLimit,
    setPageLimit,
    totalCount,
    setTotalCount,
    showAllLocalReturns,
    setShowAllLocalReturns,
    filter,
    setFilter,
    localReturns,
    setLocalReturns,
    selectedRow,
    setSelectedRow,
    sorting,
    setSorting,
    resetFilter,
    tableIsLoading,
    showOverlayLeft,
    setShowOverlayLeft,
    filterLocalInventory,
    setFilterLocalInventory,
    forceReloadLocalReturns,
    setForceReloadLocalReturns,
    initialTableId,
    setInitialTableId,
    updateOverlayLeftStates,
    storehouseFilter,
    setStorehouseFilter,
    openStorehouseFilter,
    setOpenStorehouseFilter,
    openDateRangeFilter,
    setOpenDateRangeFilter,
    startDateFilter,
    setStartDateFilter,
    endDateFilter,
    setEndDateFilter,
    openOfficeFilter,
    setOpenOfficeFilter,
    openCostCenterFilter,
    setOpenCostCenterFilter,
    officeFilter,
    setOfficeFilter,
    officeName,
    setOfficeName,
    costCenterFilter,
    setCostCenterFilter,
    costCenterName,
    setCostCenterName,
    filterReceipt,
    setFilterReceipt,
  };
  return (
    <LocalReturnsContext.Provider value={contextValues}>
      {children}
    </LocalReturnsContext.Provider>
  );
};

export default LocalReturnsProvider;
